import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import api from "../api";

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;1,400&family=DM+Sans:wght@300;400;500;600&family=DM+Mono:wght@400;500&display=swap');
.optin-root{--bg:#0d0d14;--bg-card:#14141f;--bg-field:#0a0a11;--line:#262633;--line-soft:#1c1c28;--ink:#ece9e1;--ink-soft:#9a978f;--ink-faint:#6a6862;--gold:#c8a35b;--gold-soft:#9c7e44;--green:#6fae74;--red:#c46b66;
 background:var(--bg);color:var(--ink);font-family:"DM Sans",system-ui,sans-serif;font-weight:300;line-height:1.6;min-height:100vh;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:48px 20px;background-image:radial-gradient(ellipse 70% 50% at 50% -10%,rgba(200,163,91,.07),transparent 60%)}
.optin-root *{box-sizing:border-box}
.optin-stage{width:100%;max-width:520px;animation:optrise .5s cubic-bezier(.2,.7,.2,1)}
@keyframes optrise{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:none}}
.optin-card{background:var(--bg-card);border:1px solid var(--line-soft);border-radius:18px;box-shadow:0 30px 80px -30px rgba(0,0,0,.8);padding:44px 40px 36px;position:relative;overflow:hidden}
.optin-card::before{content:"";position:absolute;inset:0 0 auto 0;height:1px;background:linear-gradient(90deg,transparent,var(--gold-soft),transparent);opacity:.5}
.optin-seal{width:62px;height:62px;margin:0 auto 22px;display:grid;place-items:center;border-radius:50%;border:1px solid var(--gold-soft);background:radial-gradient(circle at 50% 35%,rgba(200,163,91,.16),transparent 70%);position:relative}
.optin-seal::after{content:"";position:absolute;inset:5px;border-radius:50%;border:1px dashed rgba(200,163,91,.35)}
.optin-seal b{font-family:"Playfair Display",serif;font-weight:700;font-size:23px;color:var(--gold);z-index:1}
.optin-seal.green{border-color:var(--green)}.optin-seal.green b{color:var(--green)}
.optin-seal.red{border-color:var(--red)}.optin-seal.red b{color:var(--red)}
.optin-eyebrow{font-family:"DM Mono",monospace;font-size:11px;letter-spacing:.22em;text-transform:uppercase;color:var(--gold);text-align:center;margin-bottom:14px}
.optin-h1{font-family:"Playfair Display",serif;font-weight:600;font-size:clamp(26px,6vw,32px);line-height:1.15;text-align:center;color:var(--ink);margin:0 0 14px}
.optin-h1 em{font-style:italic;color:var(--gold)}
.optin-lede{text-align:center;color:var(--ink-soft);font-size:15px;line-height:1.65;max-width:42ch;margin:0 auto 30px}
.optin-form{display:flex;flex-direction:column;gap:16px}
.optin-field{display:flex;flex-direction:column;gap:7px}
.optin-lab{font-family:"DM Mono",monospace;font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:var(--ink-faint)}
.optin-input{font-family:"DM Sans",sans-serif;font-size:15px;color:var(--ink);background:var(--bg-field);border:1px solid var(--line);border-radius:10px;padding:13px 15px;transition:.18s;width:100%}
.optin-input::placeholder{color:#46453f}
.optin-input:focus{outline:none;border-color:var(--gold-soft);box-shadow:0 0 0 3px rgba(200,163,91,.12)}
.optin-consents{display:flex;flex-direction:column;gap:2px;margin-top:6px;border-top:1px solid var(--line-soft);padding-top:18px}
.optin-grplab{font-family:"DM Mono",monospace;font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:var(--ink-faint);margin-bottom:10px}
.optin-check{display:flex;gap:12px;align-items:flex-start;cursor:pointer;padding:11px 12px;border-radius:10px;transition:.15s;border:1px solid transparent}
.optin-check:hover{background:var(--bg-field)}
.optin-check input{appearance:none;-webkit-appearance:none;flex:0 0 auto;width:20px;height:20px;margin-top:1px;border-radius:6px;border:1.5px solid var(--line);background:var(--bg-field);cursor:pointer;display:grid;place-items:center;transition:.15s}
.optin-check input:checked{background:var(--gold);border-color:var(--gold)}
.optin-check input:checked::after{content:"";width:5px;height:9px;border:solid var(--bg);border-width:0 2px 2px 0;transform:rotate(45deg) translateY(-1px)}
.optin-ctxt{font-size:14px;color:var(--ink-soft);line-height:1.5}
.optin-ctxt strong{color:var(--ink);font-weight:500}
.optin-err{font-family:"DM Mono",monospace;font-size:12px;color:var(--red);min-height:0}
.optin-submit{font-family:"DM Sans",sans-serif;font-weight:600;font-size:15px;color:var(--bg);background:var(--gold);border:none;border-radius:10px;padding:15px;cursor:pointer;transition:.18s;margin-top:8px}
.optin-submit:hover{background:#d8b569;transform:translateY(-1px)}
.optin-submit:disabled{opacity:.6;cursor:default;transform:none}
.optin-fine{font-size:12.5px;color:var(--ink-faint);text-align:center;line-height:1.55;margin-top:4px}
.optin-status{text-align:center}
.optin-status p{color:var(--ink-soft);font-size:15px;max-width:40ch;margin:0 auto 12px;line-height:1.65}
.optin-mail{font-family:"DM Mono",monospace;font-size:13px;color:var(--gold);background:var(--bg-field);border:1px solid var(--line-soft);border-radius:8px;padding:9px 14px;display:inline-block;margin:8px 0 4px}
.optin-note{font-size:12.5px;color:var(--ink-faint);margin-top:20px}
.optin-ghost{display:inline-block;margin-top:22px;font-family:"DM Mono",monospace;font-size:12px;color:var(--ink-soft);text-decoration:none;border:1px solid var(--line);border-radius:999px;padding:9px 18px}
.optin-footid{text-align:center;margin-top:26px;font-family:"DM Mono",monospace;font-size:10.5px;color:var(--ink-faint);line-height:1.7}
`;

function Shell({ children }) {
  return (
    <div className="optin-root">
      <style>{CSS}</style>
      <div className="optin-stage">
        {children}
        <p className="optin-footid">SC Dottori Commercialisti S.r.l. STP · Via Ponte Marino 43, Ravenna · P.IVA 02677200392</p>
      </div>
    </div>
  );
}

export function OptinSubscribe() {
  const [f, setF] = useState({ nome: "", email: "", newsletter: false, servizi: false, informativa: false });
  const [state, setState] = useState("form");
  const [err, setErr] = useState("");
  const up = (k, v) => setF((s) => ({ ...s, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    const okEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email.trim());
    setErr("");
    if (!okEmail) { setErr("Inserisci un indirizzo email valido."); return; }
    if (!(f.newsletter || f.servizi)) { setErr("Scegli almeno una cosa da ricevere, altrimenti non c'è nulla da iscrivere."); return; }
    if (!f.informativa) { setErr("Per procedere serve la presa visione dell'informativa."); return; }
    setState("sending");
    try {
      const r = await api.post("/optin/subscribe", { email: f.email.trim(), name: f.nome.trim(), c_newsletter: f.newsletter, c_servizi: f.servizi });
      setState(r.data.status === "already_confirmed" ? "already" : "pending");
    } catch (e) { setErr(e.response?.data?.detail || e.message); setState("form"); }
  };

  if (state === "pending") return (
    <Shell><div className="optin-card optin-status"><div className="optin-seal"><b>✦</b></div>
      <p className="optin-eyebrow">Quasi fatto</p><h1 className="optin-h1">Controlla la <em>tua posta</em></h1>
      <p>Ti ho appena scritto per confermare che sei davvero tu. Apri la mail e clicca il pulsante di conferma: solo allora l'iscrizione sarà attiva.</p>
      <span className="optin-mail" data-testid="optin-pending-mail">{f.email.trim()}</span>
      <p className="optin-note">Non trovi la mail? Controlla nello spam o tra le promozioni. Il link scade tra 7 giorni.</p>
    </div></Shell>
  );
  if (state === "already") return (
    <Shell><div className="optin-card optin-status"><div className="optin-seal green"><b>✓</b></div>
      <p className="optin-eyebrow" style={{ color: "var(--green)" }}>Iscrizione già attiva</p><h1 className="optin-h1">Sei già <em>dei nostri</em></h1>
      <p>Questo indirizzo risulta già confermato. Grazie!</p></div></Shell>
  );
  return (
    <Shell>
      <div className="optin-card">
        <div className="optin-seal"><b>SC</b></div>
        <p className="optin-eyebrow">Registro contatti · 2026</p>
        <h1 className="optin-h1">Restiamo <em>in contatto?</em></h1>
        <p className="optin-lede">Ci siamo conosciuti in passato. Sto ricostruendo da zero la mia lista contatti, in modo pulito e nel rispetto delle regole. Se vuoi continuare a ricevere ciò che scrivo, confermalo qui sotto: decidi tu cosa.</p>
        <form className="optin-form" onSubmit={submit} noValidate>
          <div className="optin-field"><label className="optin-lab">Nome</label>
            <input className="optin-input" placeholder="Come ti chiami" value={f.nome} onChange={(e) => up("nome", e.target.value)} data-testid="optin-name" />
          </div>
          <div className="optin-field"><label className="optin-lab">Email</label>
            <input className="optin-input" type="email" placeholder="latua@email.it" value={f.email} onChange={(e) => up("email", e.target.value)} data-testid="optin-email" />
          </div>
          <div className="optin-consents">
            <p className="optin-grplab">Cosa vuoi ricevere</p>
            <label className="optin-check"><input type="checkbox" checked={f.newsletter} onChange={(e) => up("newsletter", e.target.checked)} data-testid="optin-newsletter" />
              <span className="optin-ctxt"><strong>La newsletter.</strong> Approfondimenti su fisco, controllo di gestione e strategia d'impresa. Niente spam, solo roba utile.</span></label>
            <label className="optin-check"><input type="checkbox" checked={f.servizi} onChange={(e) => up("servizi", e.target.checked)} data-testid="optin-servizi" />
              <span className="optin-ctxt"><strong>Novità su servizi e strumenti.</strong> Quando esce un nuovo strumento o servizio dello studio che può servirti.</span></label>
            <label className="optin-check" style={{ marginTop: 6 }}><input type="checkbox" checked={f.informativa} onChange={(e) => up("informativa", e.target.checked)} data-testid="optin-informativa" />
              <span className="optin-ctxt" style={{ color: "var(--ink)" }}>Ho letto e compreso l'<a href="https://casalisilvia.com/privacy-policy" target="_blank" rel="noopener noreferrer" data-testid="optin-privacy-link" style={{ color: "var(--gold, #c8a35b)", textDecoration: "underline" }}>informativa sul trattamento dei dati</a> (versione giugno 2026).</span></label>
          </div>
          {err && <div className="optin-err" data-testid="optin-error">{err}</div>}
          <button type="submit" className="optin-submit" disabled={state === "sending"} data-testid="optin-submit">{state === "sending" ? "Invio…" : "Confermo l'iscrizione"}</button>
          <p className="optin-fine">Ti arriverà <strong>una mail di conferma</strong>: clicca il link al suo interno per completare l'iscrizione.<br />Puoi revocare il consenso quando vuoi, con un clic.</p>
        </form>
      </div>
    </Shell>
  );
}

function RecoverBox() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const send = async () => {
    if (!email.includes("@")) return;
    try { await api.post("/optin/recover", { email: email.trim() }); } catch {}
    setDone(true);
  };
  if (done) return <p className="optin-fine" style={{ marginTop: 14 }} data-testid="recover-done">Se l'indirizzo è tra i nostri contatti, ti abbiamo appena inviato una nuova email con il link aggiornato. Controlla la posta (anche lo spam).</p>;
  return (
    <div style={{ marginTop: 16 }}>
      <p className="optin-fine">Il link potrebbe essere scaduto. Inserisci la tua email e te ne inviamo subito uno nuovo:</p>
      <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
        <input className="optin-input" type="email" placeholder="latua@email.it" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="recover-email" />
        <button className="optin-submit" style={{ whiteSpace: "nowrap", marginTop: 0, padding: "0 18px" }} onClick={send} data-testid="recover-send">Invia nuovo link</button>
      </div>
    </div>
  );
}

export function OptinConfirm() {
  const { token } = useParams();
  const [state, setState] = useState("loading");
  const [info, setInfo] = useState("");
  const [mtok, setMtok] = useState("");
  const ran = useRef(false);
  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    api.get(`/optin/confirm/${token}`)
      .then((r) => { setState("ok"); setInfo(r.data.email); setMtok(r.data.manage_token); })
      .catch((e) => { setState("err"); setInfo(e.response?.data?.detail || ""); });
  }, [token]);
  if (state === "loading") return <Shell><div className="optin-card optin-status"><p>Conferma in corso…</p></div></Shell>;
  if (state === "err") return <Shell><div className="optin-card optin-status"><div className="optin-seal red"><b>—</b></div><p className="optin-eyebrow" style={{ color: "var(--red)" }}>Link non valido</p><h1 className="optin-h1">Qualcosa non torna</h1><p>{info || "Il link di conferma non è valido o è già stato usato."}</p><RecoverBox /></div></Shell>;
  return (
    <Shell><div className="optin-card optin-status"><div className="optin-seal green"><b>✓</b></div>
      <p className="optin-eyebrow" style={{ color: "var(--green)" }}>Iscrizione attiva</p>
      <h1 className="optin-h1">Ci siamo. <em>Grazie di cuore.</em></h1>
      <p>Consenso registrato e confermato. Da ora ricevi ciò che hai scelto — e niente di più. Ho preso nota di tutto: data, ora e cosa hai accettato.</p>
      <a className="optin-ghost" href={`/p/${mtok}`} data-testid="confirm-manage">Gestisci le preferenze</a>
    </div></Shell>
  );
}

export function OptinUnsubscribe() {
  const { token } = useParams();
  const [state, setState] = useState("sending");
  const [email, setEmail] = useState("");
  const ran = useRef(false);
  // un solo clic: la disiscrizione parte subito, senza chiedere conferma
  useEffect(() => {
    if (ran.current) return; ran.current = true;
    api.post(`/optin/unsubscribe/${token}`).then((r) => { setEmail(r.data.email); setState("done"); }).catch(() => setState("err"));
  }, [token]);
  const go = async () => {
    setState("sending");
    try { const r = await api.post(`/optin/unsubscribe/${token}`); setEmail(r.data.email); setState("done"); }
    catch { setState("err"); }
  };
  if (state === "err") return <Shell><div className="optin-card optin-status"><div className="optin-seal red"><b>—</b></div><h1 className="optin-h1">Link non valido</h1><RecoverBox /></div></Shell>;
  if (state === "done") return (
    <Shell><div className="optin-card optin-status"><div className="optin-seal red"><b>—</b></div>
      <p className="optin-eyebrow" style={{ color: "var(--red)" }}>Disiscrizione completata</p>
      <h1 className="optin-h1">Fatto, <em>nessun problema.</em></h1>
      <p>Non riceverai più mie comunicazioni. Ho rimosso il tuo consenso e registrato la richiesta.</p></div></Shell>
  );
  return (
    <Shell><div className="optin-card optin-status"><div className="optin-seal"><b>?</b></div>
      <h1 className="optin-h1">Vuoi <em>disiscriverti?</em></h1>
      <p>Confermi di voler smettere di ricevere le comunicazioni a <span className="optin-mail">{email}</span>?</p>
      <button className="optin-submit" onClick={go} disabled={state === "sending"} data-testid="unsub-confirm">{state === "sending" ? "Attendere…" : "Sì, disiscrivimi"}</button>
    </div></Shell>
  );
}

export function OptinPreferences() {
  const { token } = useParams();
  const [c, setC] = useState(null);
  const [state, setState] = useState("loading");
  const [msg, setMsg] = useState("");
  const ran = useRef(false);
  useEffect(() => { if (ran.current) return; ran.current = true; api.get(`/optin/contact/${token}`).then((r) => { setC(r.data); setState("ok"); }).catch(() => setState("err")); }, [token]);
  const save = async (key, val) => {
    const next = { newsletter: c.consent_newsletter, servizi: c.consent_servizi, [key]: val };
    setC({ ...c, consent_newsletter: next.newsletter, consent_servizi: next.servizi });
    setMsg("");
    try { await api.post(`/optin/prefs/${token}`, next); setMsg("Preferenze aggiornate."); }
    catch (e) { setMsg(e.response?.data?.detail || e.message); }
  };
  if (state === "loading") return <Shell><div className="optin-card optin-status"><p>Caricamento…</p></div></Shell>;
  if (state === "err") return <Shell><div className="optin-card optin-status"><div className="optin-seal red"><b>—</b></div><h1 className="optin-h1">Link non valido</h1><RecoverBox /></div></Shell>;
  return (
    <Shell><div className="optin-card">
      <div className="optin-seal"><b>SC</b></div>
      <p className="optin-eyebrow">Le tue preferenze</p>
      <h1 className="optin-h1">Decidi <em>tu</em></h1>
      <p className="optin-lede">{c.email}</p>
      <div className="optin-consents" style={{ borderTop: "none", paddingTop: 0 }}>
        <label className="optin-check"><input type="checkbox" checked={!!c.consent_newsletter} onChange={(e) => save("newsletter", e.target.checked)} data-testid="prefs-newsletter" />
          <span className="optin-ctxt"><strong>La newsletter.</strong> Approfondimenti su fisco e impresa.</span></label>
        <label className="optin-check"><input type="checkbox" checked={!!c.consent_servizi} onChange={(e) => save("servizi", e.target.checked)} data-testid="prefs-servizi" />
          <span className="optin-ctxt"><strong>Novità su servizi e strumenti.</strong></span></label>
      </div>
      {msg && <p className="optin-fine" style={{ color: "var(--gold)" }} data-testid="prefs-msg">{msg}</p>}
      <p className="optin-fine">Togliendo entrambe le spunte l'iscrizione verrà annullata per tutte le comunicazioni.</p>
    </div></Shell>
  );
}
